import React from "react";

import notificacaoOff from "assets/svg/notificacaoOff.svg";

import { ContainerNotification, ContainerQtdNotification } from "./styles";

export interface INotificationIcon {
  tooltiTitle: string;
  qtdNotification: number;
  onClick?: () => unknown;
}

export const NotificationIcon: React.FC<INotificationIcon> = ({
  tooltiTitle,
  qtdNotification,
  onClick,
}) => {
  return (
    <ContainerNotification onClick={onClick}>
      <img src={notificacaoOff} alt={tooltiTitle} title={tooltiTitle} />
      {qtdNotification ? (
        <ContainerQtdNotification className="notifications" title={tooltiTitle}>
          <span>{qtdNotification > 9 ? "9+" : qtdNotification}</span>
        </ContainerQtdNotification>
      ) : null}
    </ContainerNotification>
  );
};

export default NotificationIcon;
